import { useRef, useEffect, useState } from "react";
import "./Carousel.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useBackground } from '../BackgroundContext';

const Carousel = () => {
  const carouselRef = useRef(null);
  const videoRef = useRef([]);
  const [scrollPosition, setScrollPosition] = useState(0);
  const { theme } = useBackground();
  const [screenWidth] = useState(window.innerWidth);
  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);

  //fontcolor change to background
  const fontChange = {
    color: theme.fontColor
  }

  const getThemeClass = () => {
    if (theme.background === "#ed243b") return "red-theme";
    if (theme.background === "#2e2e2e") return "dark-theme";
    if (theme.background === "white") return "light-theme";
    return "light-theme"; // Default
  };

  const checkScrollPosition = () => {
    const el = carouselRef.current;
    if (!el) return;
  
    setIsAtStart(el.scrollLeft === 0);
    setIsAtEnd(el.scrollLeft + el.clientWidth >= el.scrollWidth);
  };

  const handleMouseEnter = (index) => {
    if(videoRef.current[index]) {
        videoRef.current[index].play();
    }
  }

  const handleMouseLeave = (index) => {
    if(videoRef.current[index]) {
        videoRef.current[index].pause();
    }
  }

  const scrollRight = () => {
  const el = carouselRef.current;
  if (!el) return;

  const scrollAmount = screenWidth <= 500 ? 300 : 1000;

  el.scrollBy({ left: scrollAmount, behavior: 'smooth' });

  setTimeout(checkScrollPosition, 300);
};

const scrollLeft = () => {
  const el = carouselRef.current;
  if (!el) return;

  const scrollAmount = screenWidth <= 500 ? 300 : 1000;

  el.scrollBy({ left: -scrollAmount, behavior: 'smooth' });

  setTimeout(checkScrollPosition, 300);
};


useEffect(() => {
  const el = carouselRef.current;
  if (!el) return;

  el.addEventListener('scroll', checkScrollPosition);
  checkScrollPosition(); // Initial check

  return () => el.removeEventListener('scroll', checkScrollPosition);
}, []);


  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY); // Update scroll position
    };

    window.addEventListener('scroll', handleScroll); // Listen to scroll event
    return () => window.removeEventListener('scroll', handleScroll); // Cleanup
  }, []);

  const carouselSize = Math.min(6.9, 1.5 + scrollPosition / 100) + 'em';

  return (
    <div>
      <div style={{carouselSize}} className="carousel" ref={carouselRef}>
          <div>
            <a
                href="https://acuspire.ai/"
                target="_blank"
                rel="noopener noreferrer"
                >
                    <span 
                    className={`carousel-block acuspire text-center`}
                    onMouseEnter={() => handleMouseEnter(0)}
                    onMouseLeave={() => handleMouseLeave(0)}>
                    <img src="/Images/acuspire-light.png" alt="Acuspire" />
                    <video
                        ref={(e) => (videoRef.current[0] = e)}
                        className="hover-video"
                        src="/Videos/Acuspire.mp4"
                        muted
                        />
                    </span>
            </a>
          </div>
          <div>
            <a
                href="https://joboffer.com/#/"
                target="_blank"
                rel="noopener noreferrer"
                >
                    <span 
                    className={`carousel-block joboffer text-center`}
                    onMouseEnter={() => handleMouseEnter(1)}
                    onMouseLeave={() => handleMouseLeave(1)}>
                    <img src="/Images/logo-light.png" alt="Joboffer" />
                    <video
                        ref={(e) => (videoRef.current[1] = e)}
                        className="hover-video"
                        src="/Videos/Joboffer.mp4"
                        muted
                        />
                    </span>
            </a>
          </div>
        <div>
                <span
                onMouseEnter={() => handleMouseEnter(2)}
                onMouseLeave={() => handleMouseLeave(2)}
                    className="iphone carousel-block text-center">
                    <img src="/Images/hero.jpeg" alt="iphone" />
                    <video
                        ref={(e) => (videoRef.current[2] = e)}
                        className="hover-video"
                        src="/Videos/iphone.mp4"
                        muted
                        />
                </span>
                <span 
                onMouseEnter={() => handleMouseEnter(3)}
                onMouseLeave={() => handleMouseLeave(3)}
                    className="social-link carousel-block text-center">
                    <img src="/Images/Group 4.svg" alt="github" />
                    <video
                    ref={(e) => (videoRef.current[3] = e)}
                        className="hover-video"
                        src="/Videos/Social-links.mp4"
                        muted
                        />
                </span>
        </div>
        
        <div>
            <a
                href="https://github.com/nikigeor"
                target="_blank"
                rel="noopener noreferrer"
                >
                <span 
                    className="github">
                    <img src="/Images/github-mark-white.svg" alt="github" />
                    <h1>For more Projects, check out my Github</h1>
                </span>
            </a>
        </div>
      </div>
      <div className={`button-section ${getThemeClass()}`}>
        <button className="Carouselbuttons" onClick={scrollLeft} disabled={isAtStart}
        >
        <i className="fa-solid fa-chevron-left icon" style={fontChange}></i>
        </button> 
        <button className="Carouselbuttons" onClick={scrollRight} disabled={isAtEnd}
        >
        <i className="fa-solid fa-chevron-right icon" style={fontChange}></i>
        </button>
      </div>
    </div>
  );
};

export default Carousel;
